import promise from 'redux-promise';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';

const createStoreWithMiddleware = compose(applyMiddleware(
    promise,
))(createStore);

const store = createStoreWithMiddleware(reducers);

export default store;